// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e01214f","455":"4174f4e2","977":"f3b8d346"}[chunkId] + ".chunk.js";
};